import ChipList from '@components/v2/form/_components/ChipList/ChipList';
import { ChipConfig, ChipListItem } from '@components/v2/form/_components/ChipList/chipList.types';
import {
  buildChipListItem,
  resolveChipConfig,
} from '@components/v2/form/_components/ChipList/chipList.utils';
import { ReactNode } from 'react';
import { SelectOptionValue } from '../../select.types';

interface Props {
  selected: SelectOptionValue[];
  onItemDelete?: (value: SelectOptionValue) => void;
  getChipConfig?: (value: SelectOptionValue) => ChipConfig | undefined;
  getOptionLabel?: (value: SelectOptionValue) => ReactNode;
}

const SelectChips = ({ selected, onItemDelete, getChipConfig, getOptionLabel }: Props) => {
  const items: ChipListItem[] = selected.map((item) => {
    const config = resolveChipConfig(getChipConfig?.(item));

    return buildChipListItem(config, {
      key: String(item),
      fallbackLabel: getOptionLabel?.(item) ?? item,
      onDelete: onItemDelete ? () => onItemDelete(item) : undefined,
    });
  });

  return <ChipList items={items} />;
};

export default SelectChips;
